import DeviceDetector from './rtcDeviceDetectorBundle';
import React, { useEffect, useState } from 'react';
import { SDKAPPID } from './config';
import { getLatestUserSig } from './getUserSig';

function DeviceDetectComponent(props) {
  const [networkDetectInfo, setNetworkDetectInfo] = useState({});
  useEffect(() => {
    const uplinkUserId = 'uplink_test';
    const { userSig: uplinkUserSig } = getLatestUserSig(uplinkUserId);
    const downlinkUserId = 'downlink_test';
    const { userSig: downlinkUserSig } = getLatestUserSig(downlinkUserId);
    // const roomId = 999999;
    const networkDetectInfo = {
      sdkAppId: SDKAPPID,
      roomId: props.roomId,
      uplinkUserInfo: {
        uplinkUserId,
        uplinkUserSig,
      },
      downlinkUserInfo: {
        downlinkUserId,
        downlinkUserSig,
      },
    };
    setNetworkDetectInfo(networkDetectInfo);
  }, []);
  return (
    <div>
      <DeviceDetector
        visible={props.show}
        onClose={() => props.closeDetector()}
        hasCameraDetect={false}
        networkDetectInfo={networkDetectInfo}
      ></DeviceDetector>
    </div>
  );
}

export default DeviceDetectComponent;
